// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("font/GothamRnd-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("font/GothamRnd-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("font/GothamRnd-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("font/GothamRnd-Light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'gotham-font-medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: 'gotham-font-bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: 'gotham-font-book';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: 'gotham-font-light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}

.ct-grid {
  stroke: rgba(255, 255, 255, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-series-a .ct-point,
.ct-series-a .ct-line,
.ct-series-a .ct-bar,
.ct-series-a .ct-slice-donut {
  stroke: rgba(255, 255, 255, 0.8);
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label {
  color: rgba(255, 255, 255, 0.7);
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  line-height: 1;
}
html * {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background-color: #eeeeee;
  /*color: #3c4858;*/
  color: #273943;
  font-size: 14px;
  margin: 0;
  font-weight: 300;
  line-height: 1.5em;
  scrollbar-color: #a1a1a1 #e4e4e4;
  scrollbar-width: thin !important;
}

.css-isyiec-MuiTypography-root-MuiTimelineContent-root {
	line-height: 1.43 !important;
	font-family: 'gotham-font-light' !important;
}

div, textarea {
	scrollbar-color: #a1a1a1 #e4e4e4;
	scrollbar-width: thin;
}

blockquote footer:before,
blockquote small:before {
  content: "\\2014 \\00A0";
}

small {
  font-size: 80%;
}

h1 {
  font-size: 3em;
  line-height: 1.15em;
  color: #009df0;
}

h2 {
  font-size: 2.4em;
  color: #009df0;
}

h3 {
  font-size: 1.825em;
  line-height: 1.4em;
  margin: 20px 0 10px;
}

h4 {
  font-size: 1.3em;
  line-height: 1.4em;
}

h5 {
  font-size: 1.25em;
  line-height: 1.4em;
  margin-bottom: 15px;
}

h6 {
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 500;
}

blockquote p {
  font-style: italic;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4 {
  font-weight: 300;
  line-height: 1.5em;
}

body {
  font-family: 'gotham-font-light' !important;
  font-weight: 500;
  font-style: normal;
}

h1,
h2,
.h1,
.h2 {
  font-family: 'gotham-font-medium';
  font-weight: 700;
  margin-bottom: .8rem;
}

h3,
h4,
h5,
h6,
.h3,
.h4 {
  font-family: 'gotham-font-medium';
  font-weight: 700;
  margin-bottom: .8rem;
}

.gMedium {
	font-family: 'gotham-font-medium';
}

button {
  font-weight: 700;
}

a {
  color: #9c27b0;
  text-decoration: none;
}

a:hover,
a:focus {
  color: #89229b;
  text-decoration: none;
}

legend {
  border-bottom: 0;
}

* {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-tap-highlight-color: transparent;
}

*:focus {
  outline: 0;
}

a:focus,
a:active,
button:active,
button:focus,
button:hover,
button::-moz-focus-inner,
input[type="reset"]::-moz-focus-inner,
input[type="button"]::-moz-focus-inner,
input[type="submit"]::-moz-focus-inner,
select::-moz-focus-inner,
input[type="file"] > input[type="button"]::-moz-focus-inner {
  outline: 0 !important;
}

legend {
  margin-bottom: 20px;
  font-size: 21px;
}

output {
  padding-top: 8px;
  font-size: 14px;
  line-height: 1.42857;
}

label {
  font-size: 14px;
  line-height: 1.42857;
  color: #aaaaaa;
  font-weight: 400;
}

footer {
  padding: 15px 0;
}

footer ul {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}

#root {  
  /*max-width: 1760px;*/
  margin: 0 auto;
}

@media only screen and (min-width: 1024px) and (max-width: 1024px) and (orientation:portrait){
#root {
  transform: rotate(90deg);
  height: 1028px;
  width: 1369px;
  margin-top: 172px;
  margin-left: -170px;
}
}

footer ul li {
  display: inline-block;
}

footer ul li a {
  color: inherit;
  padding: 15px;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  border-radius: 3px;
  text-decoration: none;
  position: relative;
  display: block;
}

footer ul li a:hover {
  text-decoration: none;
}

@media (max-width: 991px) {
  body,
  html {
    position: relative;
    overflow-x: hidden;
  }

  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 0;
    top: 0;
    left: auto;
    right: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
  }
}
.fixed-plugin {
  /*font-family: "Raleway", "Helvetica", "Arial", sans-serif;*/
  font-weight: 300;
  line-height: 1.5em;
  position: fixed;
  top: 180px;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 120px;
}

.fixed-plugin .SocialMediaShareButton,
.fixed-plugin .github-btn {
  display: inline-block;
}

.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
  text-decoration: none;
}

.fixed-plugin .fa-cog {
  color: #ffffff;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}

.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto;
  width: 290px;
  border-radius: 0.1875rem;
  padding: 0 10px;
  position: absolute;
  color: rgba(0, 0, 0, 0.87);
  display: inline-block;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  background: #fff;
  border-radius: 3px;
}

.fixed-plugin .fa-circle-thin {
  color: #ffffff;
}

.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}

.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}

.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}

.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 3px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
  background-color: rgba(30, 30, 30, 0.97);
}

.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}

.fixed-plugin .badge-purple {
  background-color: #9c27b0;
}

.fixed-plugin .badge-blue {
  background-color: #00bcd4;
}

.fixed-plugin .badge-green {
  background-color: #4caf50;
}

.fixed-plugin .badge-orange {
  background-color: #ff9800;
}

.fixed-plugin .badge-red {
  background-color: #f44336;
}

.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 4px 0px;
  width: 25%;
  float: left;
}

.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 50px;
  min-height: inherit;
  padding: 0px;
  text-align: center;
}

.fixed-plugin li.adjustments-line p {
  margin: 0;
}

.fixed-plugin li.adjustments-line div,
.fixed-plugin li.header-title div,
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}

.fixed-plugin .adjustments-line p {
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3c4858;
}

.fixed-plugin .adjustments-line a {
  color: transparent;
}

.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}

.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}

.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #fff;
  border: 3px solid #fff;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}

.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}

.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #ffffff;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform: translateY(-15%);
  top: 27px;
  opacity: 0;
  transform-origin: 0 0;
  display: none;
}

.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 0.4em solid transparent;
  border-left: 0.4em solid rgba(0, 0, 0, 0.2);
  border-top: 0.4em solid transparent;
  right: -16px;
  top: 46px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 0.4em solid transparent;
  border-left: 0.4em solid #ffffff;
  border-top: 0.4em solid transparent;
  right: -16px;
}

.fixed-plugin .dropdown .dropdown-menu:before,
.fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 46px;
  width: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}

.fixed-plugin .dropdown.show .dropdown-menu {
  display: block;
  visibility: visible;
  opacity: 1;
  transform: translateY(-13%);
  transform-origin: 0 0;
}
.fixed-plugin.rtl-fixed-plugin {
  right: auto;
  left: 0px;
  border-radius: 0 8px 8px 0;
}
.fixed-plugin.rtl-fixed-plugin .dropdown-menu {
  right: auto;
  left: 80px;
}
* {
  letter-spacing: normal !important;
}
.video-container { 
  position: relative; 
  padding-bottom: 56.25%; 
  padding-top: 30px; 
  height: 0; 
  overflow: hidden; 
}
.video-container-2 {
  height: 100%;
  margin: 0 60px;
}
.video-container-2 > video {
  height: 55vh;
}
.video-container-2 > div, .video-container-2 > div > video,.video-container-3 > div, .video-container-3 > div > video { 
  width: 100% !important;
  height: 100% !important;
}
.video-container iframe, .video-container object, .video-container embed,.video-container-3 iframe, .video-container-3 object, .video-container-3 embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}
.labelpaginationfirst {
  border-radius:30px 0 0 30px;
}
.labelpaginationlast {
  border-radius:0 30px 30px 0;
}
.labelpagination,.labelpaginationfirst, .labelpaginationlast {
  width: 110%;
  background: #cbcbcb;
  opacity: 0.6;
  display: inline-flex;
  position: relative;
  height: 24px;
  scale: 0.8;
  align-items: normal !important;
  flex-direction: unset !important;
  justify-content: normal !important;
}
.labelpagination span,.labelpaginationfirst span, .labelpaginationlast span {
  text-align:center;
  width:100%;
  align-items: center;
  display: grid;
}
.labelpaginationlast span {
  text-align:center;
  width:85%;
}
.labelpagination:after,.labelpaginationfirst:after {
  color: #cbcbcb;
  border-left: 20px solid;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  display: inline-block;
  content: '';
  position: absolute;
  right: -20px;
}
.labelpagination:before, .labelpaginationlast:before {
  color: #F9F9F7;
  border-left: 20px solid;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  display: inline-block;
  content: '';
  right: -20px;
}

.labelpaginationsel .labelpagination:after, 
.labelpaginationsel .labelpaginationfirst:after, 
.labelpaginationselprev:after {
  color: rgba(255,136,85,0.6);
  opacity: 1;
}
.labelpaginationsel > .labelpagination, 
.labelpaginationsel > .labelpaginationfirst,
.labelpaginationsel > .labelpaginationlast, 
.labelpaginationselprev  {
  background: rgba(255,136,85,0.6);
  opacity: 1;
}

.testtest {
  color: "red"
}

.word-break {
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
}

.responsive, .responsive_nopointer {
  margin: 0 auto;
display: block;
max-width: 100%;
}

.responsive_nopointer2 {
  width: 100%;
  height:100%;
  object-fit: contain;
}

.pBox {
  margin-bottom: 0;
}

/**
* For pagination 
**/
.pagination {
  margin: 60px auto;
  display: flex;
  list-style: none;
  outline: none;
}
.pagination > .active > a{
  background-color: #009df0 ;
  border-color: #009df0 ;
  color: #fff;
}
.pagination > li > a{
  border: 1px solid #009df0 ;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  margin: 0 5px;
  padding: 5px 10px;
  outline: none;
  cursor: pointer;
  display: block;
  text-align: center;
}
.pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus{
  background-color: #009df0 ;
  border-color: #009df0;
  outline: none ;
}
.pagination > li > a, .pagination > li > span{
  color: #009df0
}
.pagination > li:first-child > a, .pagination > li:first-child > span, .pagination > li:last-child > a, .pagination > li:last-child > span{
  border-radius: unset;
  border: 0 solid #009df0 ;
  padding: 5px 10px;
  height: 100%;
  width: 100%;
  display: block;
  /*border: 1px solid #009df0;
  padding: 5px 10px;*/
}

/**
* For progress scrolling in Modules
*/
#progressBarContainer {
  position: fixed;
  margin-top:51.9px;
  z-index: 10;
  background: rgba(255,255,255,0.05);
  width: 100%;
  top: 0;
  max-width: 1920px;
}

@media only screen and (min-width: 1024px) {
  #progressBar {
    background: linear-gradient(to left, #ff8855, #ff8855);
    transform-origin: top left;
    transform: scale(0,0);
    opacity: 0;
  }

  #progressBarContainer,
  #progressBar {
    height: 10px;
  }
  /**
  * Two columns for section content
  **/
  .contentSection_columns {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }
  .contentSection_column {
    flex: 50% 1;
  }
  div.contentSection_column:nth-of-type(1) {
    padding-right: 15px;
  }
  div.contentSection_column:nth-of-type(2) {
    padding-left: 15px;
  }
}

/**
* FOr tooltip power react library
*/
/*.rpt-top {
  width: auto !important;
}*/

.dropdwnsty{
  font-family: 'gotham-font-book' !important;
  font-weight: 700;
  border: 1px solid #aaa;
  border-radius: .5em;
  cursor:pointer;
  font-size: .875rem;
}

.dropdwnsty, option {
  font: -moz-pull-down-menu;
}

/**
Foor tooltip custom
**/
.tooltipP {
  position: relative;
  border-bottom: 2.5px dotted #009df0;
  background-color: white !important;
  backface-visibility: hidden;
}

.tooltipP .tooltipPtext {
  visibility: hidden;
  min-width: 400px;
  background-color: white;
  color: #3c4858;
  border-radius: 6px;
  box-shadow: 0px 2px 20px lightgray;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 150%;
  left: 50%;
  margin-left: -200px;
  padding: 10px;
}

.tooltipP .tooltipPtext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent white transparent;
}

.tooltipP:hover .tooltipPtext {
  visibility: visible;
}

.modal-90w {
  max-width: 60%;
}

.carousel .control-next.control-arrow, .carousel .control-next.control-arrow:hover{
  background: rgba(0,0,0,0.2);
}

.carousel .control-prev.control-arrow, .carousel .control-prev.control-arrow:hover {
  background: rgba(0,0,0,0.2);
}

@media only screen and (max-width: 1536px) {
  .tooltipP .tooltipPtext {
    min-width: 300px;
    margin-left: -150px;
  }
}

@media only screen and (max-width: 960px) {
  .tooltipP .tooltipPtext {
    min-width: 250px;
    margin-left: -125px;
  }
  .video-container-2, .video-container-2 > video {
    height: auto;
  }
  .video-container-2 {
    margin: 0 15px;
  }
}

@media only screen and (max-width: 600px) {
  .tooltipP .tooltipPtext {
    min-width: 200px;
    margin-left: -100px;
  }
  .modal-90w {
    max-width: none;
  }
  ._loading_overlay_overlay {
    position: fixed;
  }
  .carousel .thumb {
	display: block
  }
}

.moveArrow:hover {
  animation-name : mymove;
  animation-iteration-count : infinite;
  animation-direction : alternate;
  animation-duration : 1s;
}

@keyframes mymove {
  from {transform: translateY(0px);}
  to {transform: translateY(20px);}
}

.card {
  border: 0 solid rgba(0,0,0,.125);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.14);
}

.modal-content {
  border-radius: 16px !important;
}

#textform, #titleform {
  border-radius: 16px !important;
}

/*Pulse */
.arrowPulseDown {
  height: auto;
  pointer-events: none;
  animation: jumpInfinite 1.5s infinite;
}
@keyframes jumpInfinite {
  0% {
    margin-top: 0;
  }
  50% {
    margin-top: 20px;
  }
  100% {
    margin-top: 0;
  }
}

/**
* For mobile-desktop text 
**/
.content-module-desktop-isfhk {
  display: inline;
}

.content-module-mobile-isfhk {
  display: none;
}

@media only screen and (max-width: 600px) {
  .content-module-desktop-isfhk {
    display: none;
  }
  
  .content-module-mobile-isfhk {
    display: inline;
  }
}

#iconModuleTransition {
  background-color: #ACD092;
  transition: background-color 2s ease-out;
}

.modal-xl {
	max-width: 1340px;
}

/**delete close icon**/
.closeContainerAM{
	position: relative;
	margin: auto;
	width: 30px;
	height: 30px;
	margin-top: 0;
	cursor: pointer;
  }
  
  .leftrightAM{
	height: 4px;
	width: 20px;
	position: absolute;
	margin-top: 0;
	background-color: #ff8855;
	border-radius: 2px;
	transform: rotate(45deg);
	transition: all .3s ease-in;
	top: 0;
	bottom: 0;
	margin: auto 0;
  }
  
  .rightleftAM{
	height: 4px;
	width: 20px;
	position: absolute;
	margin-top: 0;
	background-color: #ff8855;
	border-radius: 2px;
	transform: rotate(-45deg);
	transition: all .3s ease-in;
	top: 0;
	bottom: 0;
	margin: auto 0;
  }
  
  .closeAM{
	font-family: Helvetica, Arial, sans-serif; 
	font-size: .6em;
	text-transform: uppercase;
	letter-spacing: 2px;
	transition: all .3s ease-in;
	opacity: 0;
	margin: 25px 0 0 0px;
	position: absolute;
  }
  
  .closeContainerAM:hover .leftrightAM{
	transform: rotate(-45deg);
	background-color: rgba(203,203,203,0.2);
  }
  .closeContainerAM:hover .rightleftAM{
	transform: rotate(45deg);
	background-color: rgba(203,203,203,0.2);
  }
  .closeContainerAM:hover label{
	opacity: 1;
  }
  
  /**Scrollbar**/
::-webkit-scrollbar {
	width: 10px;
  }
  
::-webkit-scrollbar-track {
	background-color: #e4e4e4;
	border-radius: 0;
  }
  
::-webkit-scrollbar-thumb {
	background-color: #a1a1a1;
	border-radius: 100px;
  }
  

  /**date picker**/
  .react-date-picker__button .react-date-picker__button__icon {
	stroke: #ff8855;
  }

.react-date-picker__button:enabled:hover .react-date-picker__button__icon,
.react-date-picker__button:enabled:focus .react-date-picker__button__icon {
	stroke: rgba(255,136,85,0.6) !important;
}

.react-calendar__tile--now {
background: #009df0 !important;
}

.react-calendar {
font-family: 'gotham-font-light' !important;
font-size: 0.8em !important;
font-weight: 300;
}

.react-date-picker__wrapper {
	border-radius: 16px;
	padding: 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/material-dashboard-react.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,4CAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,4CAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,4CAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,4CAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EAIE,uBAAuB;EAIvB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EAKd,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;CACC,4BAA4B;CAC5B,2CAA2C;AAC5C;;AAEA;CACC,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;EAWE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;;;;EAME,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;;;;;;EAWE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,MAAM;IACN,UAAU;IACV,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;AACF;AACA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;;;EAGE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EAKE,2BAA2B;EAC3B,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,mCAAmC;EACnC,YAAY;EACZ,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,mCAAmC;EACnC,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EAKV,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,qCAAqC;EACrC,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,qCAAqC;EACrC,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,2BAA2B;EAC3B,UAAU;AACZ;AACA;;;;EAIE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB,cAAc;AACd,eAAe;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE;AACF;AACA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,cAAc;EACd;qBACmB;AACrB;;AAEA;;CAEC;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kCAAkC;EAClC,WAAW;EACX,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE;IACE,sDAAsD;IACtD,0BAA0B;IAC1B,qBAAqB;IACrB,UAAU;EACZ;;EAEA;;IAEE,YAAY;EACd;EACA;;IAEE;EACF;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;;CAEC;AACD;;EAEE;;AAEF;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;CACD;EACC;AACF;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,MAAM,0BAA0B,CAAC;EACjC,IAAI,2BAA2B,CAAC;AAClC;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;AACvC;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;AACF;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EAIzB,wCAAwC;AAC1C;;AAEA;CACC,iBAAiB;AAClB;;AAEA,sBAAsB;AACtB;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,aAAa;CACb,eAAe;EACd;;EAEA;CACD,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,wBAAwB;CACxB,2BAA2B;CAC3B,MAAM;CACN,SAAS;CACT,cAAc;EACb;;EAEA;CACD,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,yBAAyB;CACzB,2BAA2B;CAC3B,MAAM;CACN,SAAS;CACT,cAAc;EACb;;EAEA;CACD,yCAAyC;CACzC,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,2BAA2B;CAC3B,UAAU;CACV,oBAAoB;CACpB,kBAAkB;EACjB;;EAEA;CACD,yBAAyB;CACzB,uCAAuC;EACtC;EACA;CACD,wBAAwB;CACxB,uCAAuC;EACtC;EACA;CACD,UAAU;EACT;;EAEA,cAAc;AAChB;CACC,WAAW;EACV;;AAEF;CACC,yBAAyB;CACzB,gBAAgB;EACf;;AAEF;CACC,yBAAyB;CACzB,oBAAoB;EACnB;;;EAGA,gBAAgB;EAChB;CACD,eAAe;EACd;;AAEF;;CAEC,uCAAuC;AACxC;;AAEA;AACA,8BAA8B;AAC9B;;AAEA;AACA,2CAA2C;AAC3C,2BAA2B;AAC3B,gBAAgB;AAChB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB","sourcesContent":["@font-face {\n  font-family: 'gotham-font-medium';\n  src: url(font/GothamRnd-Medium.otf);\n  font-display: swap;\n}\n@font-face {\n  font-family: 'gotham-font-bold';\n  src: url(font/GothamRnd-Bold.otf);\n  font-display: swap;\n}\n@font-face {\n  font-family: 'gotham-font-book';\n  src: url(font/GothamRnd-Book.otf);\n  font-display: swap;\n}\n@font-face {\n  font-family: 'gotham-font-light';\n  src: url(font/GothamRnd-Light.otf);\n  font-display: swap;\n}\n\n.ct-grid {\n  stroke: rgba(255, 255, 255, 0.2);\n  stroke-width: 1px;\n  stroke-dasharray: 2px;\n}\n\n.ct-series-a .ct-point,\n.ct-series-a .ct-line,\n.ct-series-a .ct-bar,\n.ct-series-a .ct-slice-donut {\n  stroke: rgba(255, 255, 255, 0.8);\n}\n\n.ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.ct-chart-line .ct-label,\n.ct-chart-bar .ct-label {\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n.ct-label {\n  fill: rgba(0, 0, 0, 0.4);\n  line-height: 1;\n}\nhtml * {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nbody {\n  background-color: #eeeeee;\n  /*color: #3c4858;*/\n  color: #273943;\n  font-size: 14px;\n  margin: 0;\n  font-weight: 300;\n  line-height: 1.5em;\n  scrollbar-color: #a1a1a1 #e4e4e4;\n  scrollbar-width: thin !important;\n}\n\n.css-isyiec-MuiTypography-root-MuiTimelineContent-root {\n\tline-height: 1.43 !important;\n\tfont-family: 'gotham-font-light' !important;\n}\n\ndiv, textarea {\n\tscrollbar-color: #a1a1a1 #e4e4e4;\n\tscrollbar-width: thin;\n}\n\nblockquote footer:before,\nblockquote small:before {\n  content: \"\\2014 \\00A0\";\n}\n\nsmall {\n  font-size: 80%;\n}\n\nh1 {\n  font-size: 3em;\n  line-height: 1.15em;\n  color: #009df0;\n}\n\nh2 {\n  font-size: 2.4em;\n  color: #009df0;\n}\n\nh3 {\n  font-size: 1.825em;\n  line-height: 1.4em;\n  margin: 20px 0 10px;\n}\n\nh4 {\n  font-size: 1.3em;\n  line-height: 1.4em;\n}\n\nh5 {\n  font-size: 1.25em;\n  line-height: 1.4em;\n  margin-bottom: 15px;\n}\n\nh6 {\n  font-size: 1em;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\nblockquote p {\n  font-style: italic;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4 {\n  font-weight: 300;\n  line-height: 1.5em;\n}\n\nbody {\n  font-family: 'gotham-font-light' !important;\n  font-weight: 500;\n  font-style: normal;\n}\n\nh1,\nh2,\n.h1,\n.h2 {\n  font-family: 'gotham-font-medium';\n  font-weight: 700;\n  margin-bottom: .8rem;\n}\n\nh3,\nh4,\nh5,\nh6,\n.h3,\n.h4 {\n  font-family: 'gotham-font-medium';\n  font-weight: 700;\n  margin-bottom: .8rem;\n}\n\n.gMedium {\n\tfont-family: 'gotham-font-medium';\n}\n\nbutton {\n  font-weight: 700;\n}\n\na {\n  color: #9c27b0;\n  text-decoration: none;\n}\n\na:hover,\na:focus {\n  color: #89229b;\n  text-decoration: none;\n}\n\nlegend {\n  border-bottom: 0;\n}\n\n* {\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  -webkit-tap-highlight-color: transparent;\n}\n\n*:focus {\n  outline: 0;\n}\n\na:focus,\na:active,\nbutton:active,\nbutton:focus,\nbutton:hover,\nbutton::-moz-focus-inner,\ninput[type=\"reset\"]::-moz-focus-inner,\ninput[type=\"button\"]::-moz-focus-inner,\ninput[type=\"submit\"]::-moz-focus-inner,\nselect::-moz-focus-inner,\ninput[type=\"file\"] > input[type=\"button\"]::-moz-focus-inner {\n  outline: 0 !important;\n}\n\nlegend {\n  margin-bottom: 20px;\n  font-size: 21px;\n}\n\noutput {\n  padding-top: 8px;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n\nlabel {\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #aaaaaa;\n  font-weight: 400;\n}\n\nfooter {\n  padding: 15px 0;\n}\n\nfooter ul {\n  margin-bottom: 0;\n  padding: 0;\n  list-style: none;\n}\n\n#root {  \n  /*max-width: 1760px;*/\n  margin: 0 auto;\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1024px) and (orientation:portrait){\n#root {\n  transform: rotate(90deg);\n  height: 1028px;\n  width: 1369px;\n  margin-top: 172px;\n  margin-left: -170px;\n}\n}\n\nfooter ul li {\n  display: inline-block;\n}\n\nfooter ul li a {\n  color: inherit;\n  padding: 15px;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  border-radius: 3px;\n  text-decoration: none;\n  position: relative;\n  display: block;\n}\n\nfooter ul li a:hover {\n  text-decoration: none;\n}\n\n@media (max-width: 991px) {\n  body,\n  html {\n    position: relative;\n    overflow-x: hidden;\n  }\n\n  #bodyClick {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 0;\n    top: 0;\n    left: auto;\n    right: 260px;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n  }\n}\n.fixed-plugin {\n  /*font-family: \"Raleway\", \"Helvetica\", \"Arial\", sans-serif;*/\n  font-weight: 300;\n  line-height: 1.5em;\n  position: fixed;\n  top: 180px;\n  right: 0;\n  width: 64px;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1031;\n  border-radius: 8px 0 0 8px;\n  text-align: center;\n  top: 120px;\n}\n\n.fixed-plugin .SocialMediaShareButton,\n.fixed-plugin .github-btn {\n  display: inline-block;\n}\n\n.fixed-plugin li > a,\n.fixed-plugin .badge {\n  transition: all 0.34s;\n  -webkit-transition: all 0.34s;\n  -moz-transition: all 0.34s;\n  text-decoration: none;\n}\n\n.fixed-plugin .fa-cog {\n  color: #ffffff;\n  padding: 10px;\n  border-radius: 0 0 6px 6px;\n  width: auto;\n}\n\n.fixed-plugin .dropdown-menu {\n  right: 80px;\n  left: auto;\n  width: 290px;\n  border-radius: 0.1875rem;\n  padding: 0 10px;\n  position: absolute;\n  color: rgba(0, 0, 0, 0.87);\n  display: inline-block;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  background: #fff;\n  border-radius: 3px;\n}\n\n.fixed-plugin .fa-circle-thin {\n  color: #ffffff;\n}\n\n.fixed-plugin .active .fa-circle-thin {\n  color: #00bbff;\n}\n\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus {\n  color: #777777;\n  text-align: center;\n}\n\n.fixed-plugin img {\n  border-radius: 0;\n  width: 100%;\n  height: 100px;\n  margin: 0 auto;\n}\n\n.fixed-plugin .dropdown-menu li > a:hover,\n.fixed-plugin .dropdown-menu li > a:focus {\n  box-shadow: none;\n}\n.fixed-plugin .badge {\n  border: 3px solid #ffffff;\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 23px;\n  margin-right: 5px;\n  position: relative;\n  width: 23px;\n  background-color: rgba(30, 30, 30, 0.97);\n}\n\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover {\n  border-color: #00bbff;\n}\n\n.fixed-plugin .badge-purple {\n  background-color: #9c27b0;\n}\n\n.fixed-plugin .badge-blue {\n  background-color: #00bcd4;\n}\n\n.fixed-plugin .badge-green {\n  background-color: #4caf50;\n}\n\n.fixed-plugin .badge-orange {\n  background-color: #ff9800;\n}\n\n.fixed-plugin .badge-red {\n  background-color: #f44336;\n}\n\n.fixed-plugin h5 {\n  font-size: 14px;\n  margin: 10px;\n}\n.fixed-plugin .dropdown-menu li {\n  display: block;\n  padding: 4px 0px;\n  width: 25%;\n  float: left;\n}\n\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container {\n  width: 100%;\n  height: 50px;\n  min-height: inherit;\n  padding: 0px;\n  text-align: center;\n}\n\n.fixed-plugin li.adjustments-line p {\n  margin: 0;\n}\n\n.fixed-plugin li.adjustments-line div,\n.fixed-plugin li.header-title div,\n.fixed-plugin li.button-container div {\n  margin-bottom: 5px;\n}\n.fixed-plugin li.header-title {\n  height: 30px;\n  line-height: 25px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.fixed-plugin .adjustments-line p {\n  display: inline-block;\n  margin-bottom: 0;\n  font-size: 1em;\n  color: #3c4858;\n}\n\n.fixed-plugin .adjustments-line a {\n  color: transparent;\n}\n\n.fixed-plugin .adjustments-line a .badge-colors {\n  position: relative;\n  top: -2px;\n}\n\n.fixed-plugin .adjustments-line a a:hover,\n.fixed-plugin .adjustments-line a a:focus {\n  color: transparent;\n}\n.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: 1px solid #ddd;\n  border-radius: 0;\n  margin: 0;\n}\n\n.fixed-plugin .dropdown-menu > li > a.img-holder {\n  font-size: 16px;\n  text-align: center;\n  border-radius: 10px;\n  background-color: #fff;\n  border: 3px solid #fff;\n  padding-left: 0;\n  padding-right: 0;\n  opacity: 1;\n  cursor: pointer;\n  display: block;\n  max-height: 100px;\n  overflow: hidden;\n  padding: 0;\n}\n\n.fixed-plugin .dropdown-menu > li > a.img-holder img {\n  margin-top: auto;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder {\n  border-color: rgba(0, 187, 255, 0.53);\n}\n\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder {\n  border-color: #00bbff;\n  background-color: #ffffff;\n}\n.fixed-plugin .dropdown .dropdown-menu {\n  -webkit-transform: translateY(-15%);\n  -moz-transform: translateY(-15%);\n  -o-transform: translateY(-15%);\n  -ms-transform: translateY(-15%);\n  transform: translateY(-15%);\n  top: 27px;\n  opacity: 0;\n  transform-origin: 0 0;\n  display: none;\n}\n\n.fixed-plugin .dropdown .dropdown-menu:before {\n  border-bottom: 0.4em solid transparent;\n  border-left: 0.4em solid rgba(0, 0, 0, 0.2);\n  border-top: 0.4em solid transparent;\n  right: -16px;\n  top: 46px;\n}\n.fixed-plugin .dropdown .dropdown-menu:after {\n  border-bottom: 0.4em solid transparent;\n  border-left: 0.4em solid #ffffff;\n  border-top: 0.4em solid transparent;\n  right: -16px;\n}\n\n.fixed-plugin .dropdown .dropdown-menu:before,\n.fixed-plugin .dropdown .dropdown-menu:after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: 46px;\n  width: 16px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n}\n\n.fixed-plugin .dropdown.show .dropdown-menu {\n  display: block;\n  visibility: visible;\n  opacity: 1;\n  -webkit-transform: translateY(-13%);\n  -moz-transform: translateY(-13%);\n  -o-transform: translateY(-13%);\n  -ms-transform: translateY(-13%);\n  transform: translateY(-13%);\n  transform-origin: 0 0;\n}\n.fixed-plugin.rtl-fixed-plugin {\n  right: auto;\n  left: 0px;\n  border-radius: 0 8px 8px 0;\n}\n.fixed-plugin.rtl-fixed-plugin .dropdown-menu {\n  right: auto;\n  left: 80px;\n}\n* {\n  letter-spacing: normal !important;\n}\n.video-container { \n  position: relative; \n  padding-bottom: 56.25%; \n  padding-top: 30px; \n  height: 0; \n  overflow: hidden; \n}\n.video-container-2 {\n  height: 100%;\n  margin: 0 60px;\n}\n.video-container-2 > video {\n  height: 55vh;\n}\n.video-container-2 > div, .video-container-2 > div > video,.video-container-3 > div, .video-container-3 > div > video { \n  width: 100% !important;\n  height: 100% !important;\n}\n.video-container iframe, .video-container object, .video-container embed,.video-container-3 iframe, .video-container-3 object, .video-container-3 embed { \n  position: absolute; \n  top: 0; \n  left: 0; \n  width: 100%; \n  height: 100%; \n}\n.labelpaginationfirst {\n  border-radius:30px 0 0 30px;\n}\n.labelpaginationlast {\n  border-radius:0 30px 30px 0;\n}\n.labelpagination,.labelpaginationfirst, .labelpaginationlast {\n  width: 110%;\n  background: #cbcbcb;\n  opacity: 0.6;\n  display: inline-flex;\n  position: relative;\n  height: 24px;\n  scale: 0.8;\n  align-items: normal !important;\n  flex-direction: unset !important;\n  justify-content: normal !important;\n}\n.labelpagination span,.labelpaginationfirst span, .labelpaginationlast span {\n  text-align:center;\n  width:100%;\n  align-items: center;\n  display: grid;\n}\n.labelpaginationlast span {\n  text-align:center;\n  width:85%;\n}\n.labelpagination:after,.labelpaginationfirst:after {\n  color: #cbcbcb;\n  border-left: 20px solid;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  display: inline-block;\n  content: '';\n  position: absolute;\n  right: -20px;\n}\n.labelpagination:before, .labelpaginationlast:before {\n  color: #F9F9F7;\n  border-left: 20px solid;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  display: inline-block;\n  content: '';\n  right: -20px;\n}\n\n.labelpaginationsel .labelpagination:after, \n.labelpaginationsel .labelpaginationfirst:after, \n.labelpaginationselprev:after {\n  color: rgba(255,136,85,0.6);\n  opacity: 1;\n}\n.labelpaginationsel > .labelpagination, \n.labelpaginationsel > .labelpaginationfirst,\n.labelpaginationsel > .labelpaginationlast, \n.labelpaginationselprev  {\n  background: rgba(255,136,85,0.6);\n  opacity: 1;\n}\n\n.testtest {\n  color: \"red\"\n}\n\n.word-break {\n  -ms-word-break: break-all;\n  word-break: break-all;\n  word-break: break-word;\n}\n\n.responsive, .responsive_nopointer {\n  margin: 0 auto;\ndisplay: block;\nmax-width: 100%;\n}\n\n.responsive_nopointer2 {\n  width: 100%;\n  height:100%;\n  object-fit: contain;\n}\n\n.pBox {\n  margin-bottom: 0;\n}\n\n/**\n* For pagination \n**/\n.pagination {\n  margin: 60px auto;\n  display: flex;\n  list-style: none;\n  outline: none;\n}\n.pagination > .active > a{\n  background-color: #009df0 ;\n  border-color: #009df0 ;\n  color: #fff;\n}\n.pagination > li > a{\n  border: 1px solid #009df0 ;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  margin: 0 5px;\n  padding: 5px 10px;\n  outline: none;\n  cursor: pointer;\n  display: block;\n  text-align: center;\n}\n.pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus{\n  background-color: #009df0 ;\n  border-color: #009df0;\n  outline: none ;\n}\n.pagination > li > a, .pagination > li > span{\n  color: #009df0\n}\n.pagination > li:first-child > a, .pagination > li:first-child > span, .pagination > li:last-child > a, .pagination > li:last-child > span{\n  border-radius: unset;\n  border: 0 solid #009df0 ;\n  padding: 5px 10px;\n  height: 100%;\n  width: 100%;\n  display: block;\n  /*border: 1px solid #009df0;\n  padding: 5px 10px;*/\n}\n\n/**\n* For progress scrolling in Modules\n*/\n#progressBarContainer {\n  position: fixed;\n  margin-top:51.9px;\n  z-index: 10;\n  background: rgba(255,255,255,0.05);\n  width: 100%;\n  top: 0;\n  max-width: 1920px;\n}\n\n@media only screen and (min-width: 1024px) {\n  #progressBar {\n    background: linear-gradient(to left, #ff8855, #ff8855);\n    transform-origin: top left;\n    transform: scale(0,0);\n    opacity: 0;\n  }\n\n  #progressBarContainer,\n  #progressBar {\n    height: 10px;\n  }\n  /**\n  * Two columns for section content\n  **/\n  .contentSection_columns {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 100%;\n  }\n  .contentSection_column {\n    flex: 50%;\n  }\n  div.contentSection_column:nth-of-type(1) {\n    padding-right: 15px;\n  }\n  div.contentSection_column:nth-of-type(2) {\n    padding-left: 15px;\n  }\n}\n\n/**\n* FOr tooltip power react library\n*/\n/*.rpt-top {\n  width: auto !important;\n}*/\n\n.dropdwnsty{\n  font-family: 'gotham-font-book' !important;\n  font-weight: 700;\n  border: 1px solid #aaa;\n  border-radius: .5em;\n  cursor:pointer;\n  font-size: .875rem;\n}\n\n.dropdwnsty, option {\n  font: -moz-pull-down-menu;\n}\n\n/**\nFoor tooltip custom\n**/\n.tooltipP {\n  position: relative;\n  border-bottom: 2.5px dotted #009df0;\n  background-color: white !important;\n  backface-visibility: hidden;\n}\n\n.tooltipP .tooltipPtext {\n  visibility: hidden;\n  min-width: 400px;\n  background-color: white;\n  color: #3c4858;\n  border-radius: 6px;\n  box-shadow: 0px 2px 20px lightgray;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  top: 150%;\n  left: 50%;\n  margin-left: -200px;\n  padding: 10px;\n}\n\n.tooltipP .tooltipPtext::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent white transparent;\n}\n\n.tooltipP:hover .tooltipPtext {\n  visibility: visible;\n}\n\n.modal-90w {\n  max-width: 60%;\n}\n\n.carousel .control-next.control-arrow, .carousel .control-next.control-arrow:hover{\n  background: rgba(0,0,0,0.2);\n}\n\n.carousel .control-prev.control-arrow, .carousel .control-prev.control-arrow:hover {\n  background: rgba(0,0,0,0.2);\n}\n\n@media only screen and (max-width: 1536px) {\n  .tooltipP .tooltipPtext {\n    min-width: 300px;\n    margin-left: -150px;\n  }\n}\n\n@media only screen and (max-width: 960px) {\n  .tooltipP .tooltipPtext {\n    min-width: 250px;\n    margin-left: -125px;\n  }\n  .video-container-2, .video-container-2 > video {\n    height: auto;\n  }\n  .video-container-2 {\n    margin: 0 15px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .tooltipP .tooltipPtext {\n    min-width: 200px;\n    margin-left: -100px;\n  }\n  .modal-90w {\n    max-width: none;\n  }\n  ._loading_overlay_overlay {\n    position: fixed;\n  }\n  .carousel .thumb {\n\tdisplay: block\n  }\n}\n\n.moveArrow:hover {\n  animation-name : mymove;\n  animation-iteration-count : infinite;\n  animation-direction : alternate;\n  animation-duration : 1s;\n}\n\n@keyframes mymove {\n  from {transform: translateY(0px);}\n  to {transform: translateY(20px);}\n}\n\n.card {\n  border: 0 solid rgba(0,0,0,.125);\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.14);\n}\n\n.modal-content {\n  border-radius: 16px !important;\n}\n\n#textform, #titleform {\n  border-radius: 16px !important;\n}\n\n/*Pulse */\n.arrowPulseDown {\n  height: auto;\n  pointer-events: none;\n  animation: jumpInfinite 1.5s infinite;\n}\n@keyframes jumpInfinite {\n  0% {\n    margin-top: 0;\n  }\n  50% {\n    margin-top: 20px;\n  }\n  100% {\n    margin-top: 0;\n  }\n}\n\n/**\n* For mobile-desktop text \n**/\n.content-module-desktop-isfhk {\n  display: inline;\n}\n\n.content-module-mobile-isfhk {\n  display: none;\n}\n\n@media only screen and (max-width: 600px) {\n  .content-module-desktop-isfhk {\n    display: none;\n  }\n  \n  .content-module-mobile-isfhk {\n    display: inline;\n  }\n}\n\n#iconModuleTransition {\n  background-color: #ACD092;\n  -webkit-transition: background-color 2s ease-out;\n  -moz-transition: background-color 2s ease-out;\n  -o-transition: background-color 2s ease-out;\n  transition: background-color 2s ease-out;\n}\n\n.modal-xl {\n\tmax-width: 1340px;\n}\n\n/**delete close icon**/\n.closeContainerAM{\n\tposition: relative;\n\tmargin: auto;\n\twidth: 30px;\n\theight: 30px;\n\tmargin-top: 0;\n\tcursor: pointer;\n  }\n  \n  .leftrightAM{\n\theight: 4px;\n\twidth: 20px;\n\tposition: absolute;\n\tmargin-top: 0;\n\tbackground-color: #ff8855;\n\tborder-radius: 2px;\n\ttransform: rotate(45deg);\n\ttransition: all .3s ease-in;\n\ttop: 0;\n\tbottom: 0;\n\tmargin: auto 0;\n  }\n  \n  .rightleftAM{\n\theight: 4px;\n\twidth: 20px;\n\tposition: absolute;\n\tmargin-top: 0;\n\tbackground-color: #ff8855;\n\tborder-radius: 2px;\n\ttransform: rotate(-45deg);\n\ttransition: all .3s ease-in;\n\ttop: 0;\n\tbottom: 0;\n\tmargin: auto 0;\n  }\n  \n  .closeAM{\n\tfont-family: Helvetica, Arial, sans-serif; \n\tfont-size: .6em;\n\ttext-transform: uppercase;\n\tletter-spacing: 2px;\n\ttransition: all .3s ease-in;\n\topacity: 0;\n\tmargin: 25px 0 0 0px;\n\tposition: absolute;\n  }\n  \n  .closeContainerAM:hover .leftrightAM{\n\ttransform: rotate(-45deg);\n\tbackground-color: rgba(203,203,203,0.2);\n  }\n  .closeContainerAM:hover .rightleftAM{\n\ttransform: rotate(45deg);\n\tbackground-color: rgba(203,203,203,0.2);\n  }\n  .closeContainerAM:hover label{\n\topacity: 1;\n  }\n  \n  /**Scrollbar**/\n::-webkit-scrollbar {\n\twidth: 10px;\n  }\n  \n::-webkit-scrollbar-track {\n\tbackground-color: #e4e4e4;\n\tborder-radius: 0;\n  }\n  \n::-webkit-scrollbar-thumb {\n\tbackground-color: #a1a1a1;\n\tborder-radius: 100px;\n  }\n  \n\n  /**date picker**/\n  .react-date-picker__button .react-date-picker__button__icon {\n\tstroke: #ff8855;\n  }\n\n.react-date-picker__button:enabled:hover .react-date-picker__button__icon,\n.react-date-picker__button:enabled:focus .react-date-picker__button__icon {\n\tstroke: rgba(255,136,85,0.6) !important;\n}\n\n.react-calendar__tile--now {\nbackground: #009df0 !important;\n}\n\n.react-calendar {\nfont-family: 'gotham-font-light' !important;\nfont-size: 0.8em !important;\nfont-weight: 300;\n}\n\n.react-date-picker__wrapper {\n\tborder-radius: 16px;\n\tpadding: 0 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
